import { useTranslation } from 'react-i18next';
import { Link } from '@fluent/ui';

/**
 * LEGAL_BASE — origin of the public legal pages (Astro landing site).
 * Hardcoded rather than env-derived: the URLs are part of the Paddle KYC
 * submission and must remain stable for that compliance review.
 */
const LEGAL_BASE = 'https://fluent.ge';

export const LEGAL_URLS = {
  terms: `${LEGAL_BASE}/terms`,
  privacy: `${LEGAL_BASE}/privacy`,
  refund: `${LEGAL_BASE}/refund`,
} as const;

export interface LegalLinksProps {
  /** Show the Refund Policy link too. Default true (required next to payment). */
  includeRefund?: boolean;
}

/**
 * Inline row of legal links — Terms · Privacy · Refunds.
 * Used at the foot of Paywall and Profile so users always have one tap to
 * the public legal pages required by Paddle KYC.
 */
export function LegalLinks({ includeRefund = true }: LegalLinksProps) {
  const { t } = useTranslation();
  const sep = t('legal.separator');
  return (
    <div
      className="fluent-legal-links"
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: 4,
        fontSize: 'var(--text-xs)',
        textAlign: 'center',
      }}
    >
      <Link href={LEGAL_BASE} tone="muted" underline="hover">
        fluent.ge
      </Link>
      <span aria-hidden="true" style={{ color: 'var(--color-text-soft)' }}>{sep}</span>
      <Link href={LEGAL_URLS.terms} tone="muted" underline="hover">
        {t('legal.terms')}
      </Link>
      <span aria-hidden="true" style={{ color: 'var(--color-text-soft)' }}>{sep}</span>
      <Link href={LEGAL_URLS.privacy} tone="muted" underline="hover">
        {t('legal.privacy')}
      </Link>
      {includeRefund && (
        <>
          <span aria-hidden="true" style={{ color: 'var(--color-text-soft)' }}>{sep}</span>
          <Link href={LEGAL_URLS.refund} tone="muted" underline="hover">
            {t('legal.refund')}
          </Link>
        </>
      )}
    </div>
  );
}
